<template>
  <div class="home">
    <!--    banner-->
    <el-carousel indicator-position="none" height="400px" arrow="never">
      <el-carousel-item v-for="(item,index) in banner" :key="index">
        <div class="objImg img" :style="'backgroundImage: url('+item+')'">
          <div class="bannerTxt">
            <h2>欢迎加入心理亦笙<br/>探索在线心理咨询</h2>
            <p>我们一直在寻找新的人才，<br/>以增加我们远程医疗专业平台，<br/>探索在线心理咨询</p>
<!--            <div>
              <el-button>精神科医生注册</el-button>
              <el-button>心理专家注册</el-button>
            </div>-->
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>

    <!--    医生注册-->
    <div class="registered news">
      <div class="first commonClass">
        <div class="registeredImg">
          <div class="mark flex">精神科医生注册</div>
        </div>
        <div class="right">
          <div class="content">
            <div class="flex">
              <img src="../../assets/images/icon_1.png" alt="">
              <div><h3>灵活的工作时间</h3>
                <p>随时随地与最适合您的客户联系</p></div>
            </div>
            <div class="flex">
              <img src="../../assets/images/icon_2.png" alt="">
              <div><h3>培训和成长的机会</h3>
                <p>接受有关远程咨询的培训，并应您的要求继续提供支持和同行咨询</p></div>
            </div>
            <div class="flex">
              <img src="../../assets/images/icon_3.png" alt="">
              <div><h3>无开销</h3>
                <p>我们提交保险索赔，检查患者资格，并处理与私人执业相关的其他费用</p></div>
            </div>
            <div class="flex">
              <img src="../../assets/images/icon_4.png" alt="">
              <div><h3>可靠的收入</h3>
                <p>选择您的案例，赚取月收入，并有资格获得额外的奖金</p></div>
            </div>
          </div>
<!--          <el-button class="btn">立即注册</el-button>-->
        </div>
      </div>
      <div class="second commonClass">
        <div class="right">
          <div class="content">
            <div class="flex">
              <img src="../../assets/images/icon_4.png" alt="">
              <div><h3>可靠的收入</h3>
                <p>选择您的案例，赚取月收入，并有资格获得额外的奖金</p></div>
            </div>
            <div class="flex">
              <img src="../../assets/images/icon_2.png" alt="">
              <div><h3>导师计划</h3>
                <p>与我们经验丰富的治疗师团队联系，他们将帮助您更好地进行心理咨询</p></div>
            </div>
            <div class="flex">
              <img src="../../assets/images/icon_3.png" alt="">
              <div><h3>无开销</h3>
                <p>我们提交保险索赔，检查患者资格，并处理与私人执业相关的其他费用</p></div>
            </div>
            <div class="flex">
              <img src="../../assets/images/icon_1.png" alt="">
              <div><h3>灵活的工作时间</h3>
                <p>随时随地与最适合您的客户联系</p></div>
            </div>
            <div class="flex">
              <img src="../../assets/images/icon_5.png" alt="">
              <div><h3>交流社区</h3>
                <p>与其他成千上万的有才华的临床医生一起交流资源和支持</p></div>
            </div>
            <div class="flex">
              <img src="../../assets/images/icon_6.png" alt="">
              <div><h3>同周开始</h3>
                <p>在申请后几天内为您匹配合适的客户</p></div>
            </div>

          </div>
<!--          <el-button class="btn">立即注册</el-button>-->
        </div>
        <div class="registeredImg">
          <div class="mark flex">心理专家注册</div>
        </div>
      </div>
    </div>

    <!--    如何注册-->
    <div class="help news">
      <h2>如何注册</h2>
      <div class="helpList flex">
        <template v-for="(item,ind) in helpList">
          <div class="listContent" :key="'a'+ind">
            <img :src="item.img" alt="" width="160">
            <h4>{{ item.tit }}</h4>
            <p>{{ item.text }}</p>
          </div>
          <div class="" :key="'b'+ind" :style="{'display':(ind==2?'none':'')}"><img
              src="../../assets/images/help_04.png" alt=""></div>
        </template>
      </div>
<!--      <el-button>立即注册</el-button>-->
    </div>

    <!--    注册要求-->
    <div class="requirementBg"></div>
    <div class="requirement">
      <h2>注册申请要求</h2>
      <div class="requirementContent">
        <h4>1、职业资格</h4>
        <p>拥有执业所在地法律要求的执业资格。</p>
        <h4>2、专业培训</h4>
        <p>已完成至少一个心理咨询/心理治疗的系统长程培训，培训内容须包含心理咨询的伦理、评估、理论、技术等诸多方面，培训成绩达到所参与培训的合格水平，为期不少于2年（同时培训学时不低于200小时）。短程的工作坊暂不算作内。</p>
        <h4>3、咨询经验</h4>
        <p>来访付费的个体咨询小时数不低于1500小时。此处的咨询仅限由来访者付费的、同时具备严格设置的面对面或视频咨询。文字和语音的咨询等不算在内。</p>
        <h4>4、被督导经历</h4>
        <p>接受过个体督导，个体督导小时数不低于100小时。另外，如若咨询师从业不满5年，应继续接受督导。以上督导要求均不包括朋辈督导。此处的督导仅限具备严格设置的面对面或视频督导，文字、语音或临时的探讨不算在内。</p>
        <h4>5、案例报告</h4>
        <p>满足如上条件的咨询师，请提交一份案例报告。所呈报的个案需要咨询次数在12次以上。报告无具体格式要求，请尽量呈现出咨询师近期的工作状态和专业能力。（直接在入驻申请表中上传即可）</p>
      </div>
      <!--      <div class="left floatCommon">
              <h3>精神科医生</h3>
              <ul>
                <li>A LCSW, LMFT, LPCC, or PhD in Clinical Psychology</li>
                <li>Submission of a fully completed, signed CAQH application</li>
                <li>- MD/DO: You must have completed a residency in psychiatry. - NP: You must have either a Psychiatric
                  Mental Health Nurse Practitioner (PMHNP) certificate or 2+ years psychiatry experience.
                </li>
              </ul>
              <el-button>立即注册</el-button>
            </div>
            <div class="right floatCommon">
              <h3>心理专家</h3>
              <ul>
                <li>A LCSW, LMFT, LPCC, or PhD in Clinical Psychology</li>
                <li>A LCSW, LMFT, LPCC, or PhD in Clinical Psychology</li>
                <li>A LCSW, LMFT, LPCC, or PhD in Clinical Psychology</li>
              </ul>
              <el-button>立即注册</el-button>
            </div>-->
      <div style="clear: both"></div>
    </div>

    <!--    评价-->
    <div class="news evaluation" >
      <h2>心理亦笙的 <span>心理专家</span> 和 <span>精神科医生</span> 评价</h2>
      <div class="userSwiperOptions" style="width:1200px">
        <swiper ref="drugSwiper" :options="userSwiperOptions">
          <swiper-slide v-for="item  in teamDoctorList" :key="item.id">
            <div class="consultantList">
              <div class="img" :class="{'default-headImg':item.headImgPath}"
                   :style="{backgroundImage: (item.headImgPath? 'url('+item.headImgPath+')':'')}"
                   :gender="!item.headImgPath?item.gender:''">
                <div class="mark">
                  <img src="../../assets/images/vector.png" alt="">
                </div>
              </div>
              <h4 class="enName">{{ item.fullName }}{{ item.enName ? item.enName : '' }}</h4>
              <p class="enName">{{ item.technicalTitle }}</p>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <!--    常见问题-->
    <div class="why">
      <div class="news">
        <h2>常见问题</h2>
        <el-collapse class="dobut" v-model="active" accordion>
          <el-collapse-item
              class="problemOptions" v-for="(item,index) in problemOptions"
              :key="index" :name="index">
            <template slot="title"><h3 class="flex"><i class="icon">Q</i>{{ item.itemName }}</h3></template>
            <p class="answer">
              <span class=" icon">A</span>
              <span class="itemDesc">{{ item.itemDesc }}</span>
            </p>
          </el-collapse-item>
          <router-link to="/doubt" class="readMore">查看更多疑惑>></router-link>
        </el-collapse>
      </div>
    </div>

    <!--    尾部-->
    <div class="introduce">
      <div class="news">
        <div class="ysh">
          <img src="../../assets/img/logoFotter.png" alt="">
          <p>吸纳中外的心理、精神和神经方面的专家学者参与，为中美欧华人及留学生提供专业的心理辅导与专业帮助！</p>
          <p>同时，这个平台也给中美业界同行们提供最新的学术研究新闻，为中国同行提供便利高效的精神学药库等其他方面的服务。</p>
          <p>欢迎您加盟我们团队，为用户服务！</p>
        </div>
        <div class="concact">
          <p class="tit">联系我们</p>
          <div class="concactInfo">
            <p>{{ contact.email }}</p>
            <p>{{ contact.tel }}</p>
          </div>
          <div class="showFeedbackDialog">
            <p class="tit">咨询反馈</p>
            <div class="inputFeed flex" @click="showFeedbackDialog()">
              <span>请留下您的咨询感受</span>
              <span>提交</span>
            </div>
          </div>

        </div>
        <div class="shortcutMenu">
          <p class="tit">快捷菜单</p>
          <div class="listMenu">
            <a v-for="(item,index) in shortcutMenu" :href="item.path" :key="index">{{ item.tit }}</a>
          </div>
        </div>
        <div class="peopleNum flex">
          <div>
            <h1>{{ statistics.doctors }}</h1>
            <span>注册医生</span>
          </div>
          <div>
            <h1>{{ statistics.users }}</h1>
            <span>注册用户</span>
          </div>
        </div>
        <div class="peopleNum flex">
          <div>
            <h1>{{ statistics.appoints }}</h1>
            <span>咨询次数</span>
          </div>
          <div>
            <h1>{{ statistics.visits }}</h1>
            <span>访问次数</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 登录弹窗 -->
    <loginDialog ref="loginDialog"></loginDialog>

    <!--    用户反馈对话框 start-->
    <el-dialog top="0" :visible.sync="showAddFeedbackDialog" :close-on-click-modal="false"
               :show-close="false" width="500px" class="updateMem" :close-on-press-escape="false">
      <template #title>
        <h1 class="tit">用户反馈</h1>
      </template>
      <el-form :model="addFeedbackData" class="rowsInfo" label-suffix="：" label-width="90px" :rules="addFeedbackRules"
               ref="addFeedbackForm">
        <el-form-item label="标题" prop="title">
          <el-input v-model="addFeedbackData.title" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contact">
          <el-input v-model="addFeedbackData.contact" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input type="textarea" :rows="4" v-model="addFeedbackData.content"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeFeedbackDialog()">取 消</el-button>
        <el-button type="primary" @click="addFeedback()">确 定</el-button>
      </div>
    </el-dialog>
    <!--    用户反馈对话框 end-->

    <!--    悬浮框-->
    <suspensionDrawer></suspensionDrawer>
  </div>

</template>

<script>
import loginDialog from "@/components/loginDialog";
import base from "@/api/common";
import suspensionDrawer from "@/components/suspensionDrawer";
import {Swiper, SwiperSlide} from "vue-awesome-swiper";
require("swiper/dist/css/swiper.css");
export default {
  name: "recruiting",
  data() {
    return {
      // 尾部信息
      contact: {
        email: 'service@yshinfo.com',
        tel: '0755-28291983'
      },
      // 统计
      statistics: {
        doctors: 126,
        appoints: 1653,
        users: 3692,
        visits: 7655
      },
      // 导航
      shortcutMenu: [
        {tit: '我要咨询', path: '/consult'},
        {tit: '专业医生', path: '/famousDoctor'},
        {tit: '每日研究', path: '/study'},
        {tit: '专业用药', path: '/medication'},
        {tit: '新闻资讯', path: '/news'},
        {tit: '专家会议', path: '/consultation'}
      ],
      // 用户反馈
      showAddFeedbackDialog: false, //展示用户反馈对话框
      addFeedbackData: {//添加用户反馈的数据
        title: null,//标题
        content: null,//内容
        contact: null,//联系方式
      },
      addFeedbackRules: {//用户反馈校验
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'},
          {max: 255, message: '长度最长为255', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '请输入反馈内容', trigger: 'blur'},
        ],
        contact: [
          {max: 255, message: '长度最长为255', trigger: 'blur'}
        ],
      },
      // 用户疑惑
      problemOptions: [],
      active: 0,
      banner: [require('../../assets/images/recruitingBanner.png'),],
      // 帮助
      helpList: [
        {img: require('../../assets/images/help_01.png'), tit: '提交申请', text: '收到您的申请后，我们将通过电子邮件联系您'},
        {img: require('../../assets/images/help_05.png'), tit: '匹配治疗师', text: '了解在线心理咨询及如何使用平台，如有需要，始终提供支持'},
        {img: require('../../assets/images/help_06.png'), tit: '开始视频', text: '从一致的转介中选择您的案例并管理您的日常安排'},
      ],
      userSwiperOptions: {
        slidesPerView: 4,
        speed: 1500,
        loop: true,
        autoplay: 3000,
        autoplayDisableOnInteraction: true,
      },
      teamDoctorList: []
    }
  },
  mounted() {
    // 统计
    this.$ajax.get(base.basePath + 'auth/auth-doctor/statistics').then(res => {
      if (res.data.status === 'success') {
        this.statistics.doctors = res.data.doctors;
        this.statistics.appoints = res.data.appoints;
      }
    });
    this.$ajax.get(base.basePath + 'auth/auth-user/statistics').then(res => {
      if (res.data.status === 'success') {
        this.statistics.users = res.data.users;
      }
    });
    this.$ajax.get(base.basePath + 'communication/comm-visit-history/visits/count').then(res => {
      if (res.data.status === 'success') {
        this.statistics.visits = res.data.data;
      }
    })
    //获取用户疑惑
    this.$ajax.get(base.api.dict.userQA).then((res) => {
      if (res.data.status === 'success') {
        this.problemOptions = res.data.list.slice(0, 5);
      }
    })
    // 注册医生+咨询师
    let condition = {
      current: 1,
      size: 15,
      orderByNewest: 1
    };
    this.$ajax.post(base.api.doctor.condition, condition).then(res => {
      if (res.data.status === 'success') {
        this.teamDoctorList = res.data.rows;
      }
    });
    $(".contentIndex").animate({scrollTop: '0px'}, 800);
  },
  methods: {
    //添加用户反馈
    addFeedback() {
      this.$refs['addFeedbackForm'].validate((valid) => {
        if (valid) {
          let that = this;
          this.$ajax.post(base.api.feedback.add, this.addFeedbackData).then((res) => {
            if (res.data.status === 'success') {
              that.$message.success('提交成功');
            } else {
              that.$message.error(res.data.message);
            }
          }).catch((err) => {
            console.error(err);
            that.$message.error("操作异常");
          }).finally(() => {
            that.closeFeedbackDialog();
          })
        } else {
          this.$message.error("请检查数据");
          return false;
        }
      });
    },
    closeFeedbackDialog() {
      this.addFeedbackData = {
        title: null,
        content: null,
        contact: null,
      };
      this.showAddFeedbackDialog = false;
    },
    async showFeedbackDialog() {
      let that = this;
      let user = await base.utils.getCurrent();
      if (user == null) {
        that.$refs.loginDialog.dialogVisible = true;
        that.$refs.loginDialog.reloadCode('vcode-user');
        that.$refs.loginDialog.successUrl = '/index';
      } else {
        this.showAddFeedbackDialog = true;
      }
    },
    // 用户反馈
    feedbackHead(obj) {
      if (obj.headImgPath) {
        return obj.headImgPath
      } else {
        if (obj.gender === 1) {
          return '/static/imgs/feedback_man.png'
        } else if (obj.gender === 0) {
          return '/static/imgs/feedback_woman.png'
        } else {
          return '/static/imgs/feedback_man.png'
        }
      }
    },
  },
  components: {
    loginDialog,
    suspensionDrawer,
    Swiper,
    SwiperSlide,
  },
  computed: {
    swiper() {
      return this.$refs.drugSwiper.$swiper
    },
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/css/home';

.help {
  border: none;
}
</style>
